export default __webpack_public_path__ + "static/media/apple.8f2189a9.svg";